
import React, { useState, useRef } from 'react';
import { Menu, LogOut, User as UserIcon } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { logout } from '../../store/authSlice';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  toggleSidebar: () => void;
}

const Header: React.FC<HeaderProps> = ({ toggleSidebar }) => {
  const dispatch = useDispatch();


  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    setDropdownOpen(false);
  };

  const handleProfile = () => {
    setDropdownOpen(false);
    navigate('/profile');
  };

  // Close dropdown on outside click
  React.useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [dropdownOpen]);

  return (
    <header className="fixed top-0 left-0 right-0 h-16 bg-[#0071bd] text-white shadow-lg z-50">
      <div className="flex items-center justify-between h-full px-4">
        <div className="flex items-center">
          <button
            onClick={toggleSidebar}
            className="p-2 hover:bg-[#0062a3] rounded-lg"
          >
            <Menu className="w-6 h-6" />
          </button>
          <h1 className="ml-4 text-xl font-semibold">Candidate Management</h1>
        </div>
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setDropdownOpen((v) => !v)}
            className="flex items-center justify-center w-10 h-10 rounded-full bg-white hover:bg-blue-100 border-2 border-[#0071bd] text-[#0071bd] focus:outline-none"
            title="Profile"
          >
            <UserIcon size={24} />
          </button>
          {dropdownOpen && (
            <div className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-lg py-2 z-50 border border-gray-100">
              <button
                onClick={handleProfile}
                className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-blue-50 gap-2"
              >
                <UserIcon size={18} className="text-[#0071bd]" />
                <span>Profile</span>
              </button>
              <button
                onClick={handleLogout}
                className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-blue-50 gap-2"
              >
                <LogOut size={18} className="text-red-500" />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;